import React, { useContext } from "react";
import ButtonPrimary from "../SharedComponents/ButtonPrimary";
import Header from "../SharedComponents/Header";
import NavBar from "../SharedComponents/Navbar";
// import Card from "./Product/Card";
import useSticky from "../Hooks/useSticky";

import StarRatings from "react-star-ratings";
import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Store from "../Store";
import Rating from "../Rating";
import Modal from "../SharedComponents/Modal";
import GlobalStates from "../../layouts/GlobalStates";
import { GlobalStateContext } from "./../../layouts/GlobalStates";

export default function Layout(props) {
    useSticky([
        {
            type: "feedback-chrome",
            height: 180,
            min: 0,
            offset: 0,
        },
    ]);

    const moreHandle = () => {
        // expands features table
        setMore(!more);
    };
    const { t, i18n } = useTranslation();

    const id = props.id;
    //   alert(id);
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;

    const [more, setMore] = React.useState(false);
    const [descMore, setDescMore] = React.useState(false);
    const [scroll, setScroll] = React.useState(0);
    const [descHeight, setDescHeight] = React.useState();
    const [currentTab, setCurrentTab] = React.useState(1);

    const fullDescription = result?.ajax?.item?.description || "";
    const displayDescription = descMore
        ? fullDescription
        : fullDescription.length > 200
        ? fullDescription.substr(0, 200) + "..."
        : fullDescription;
    const descriptionParagraphs = displayDescription
        .replace(/\r\n/g, "\n")
        .split(/\n+/)
        .map((p) => p.trim())
        .filter(Boolean);

    return (
        <>
            {result.data.form ? (
                <div className="main-container">
                    <Header
                        photo={result.ajax.item.photo}
                        productName={result.ajax.item.name}
                        logo={result.ajax.item.company_logo}
                    />

                    <div
                        className="product"
                        style={{ marginTop: scroll < 110 ? null : 20 }}
                    >
                        {[1142, 1143, 1144, 1145].includes(result?.ajax?.item?.item_type) && <div className="rating-info">
                            <div className="rating-stars" dir="ltr">
                                <style>
                                    {`
                                        .star-container svg path {
                                            transform: scale(1.2);
                                        }
                                    `}
                                </style>
                                <StarRatings
                                    starRatedColor="rgb(254, 183, 48)"
                                    starEmptyColor="#ccc"
                                    rating={result.ajax.item.computed_score}
                                    starDimension="32px"
                                    starSpacing="1px"
                                    svgIconPath="M18.1359 1.48359C18.5216 0.821321 19.4784 0.821321 19.8641 1.48359L25.5671 11.2751C25.7084 11.5177 25.9452 11.6897 26.2196 11.7491L37.2942 14.1473C38.0432 14.3095 38.3389 15.2194 37.8282 15.7909L30.2783 24.2405C30.0913 24.4499 30.0008 24.7282 30.0291 25.0076L31.1705 36.2812C31.2477 37.0437 30.4737 37.6061 29.7724 37.297L19.4032 32.7277C19.1463 32.6145 18.8537 32.6145 18.5968 32.7277L8.22762 37.297C7.52628 37.6061 6.75226 37.0437 6.82946 36.2812L7.97091 25.0076C7.99919 24.7282 7.90875 24.4499 7.72169 24.2405L0.171763 15.7909C-0.338892 15.2194 -0.0432378 14.3095 0.705815 14.1473L11.7804 11.7491C12.0548 11.6897 12.2916 11.5177 12.4329 11.2751L18.1359 1.48359Z"
                                />
                            </div>
                            <div className="rating-num">
                                <p></p>
                                <p>
                                    {Math.round(
                                        (result.ajax.item.computed_score || 0) *
                                            100
                                    ) / 100}{" "}
                                    <span>
                                        / {result.ajax.item.feedback_count}{" "}
                                        {t("feedback")}
                                    </span>
                                </p>
                            </div>
                        </div>}
                        {fullDescription && (
                            <div className="product-des">
                                {descriptionParagraphs.map(
                                    (paragraph, index) => {
                                        const isLast =
                                            index ===
                                            descriptionParagraphs.length - 1;
                                        const showToggle =
                                            fullDescription.length > 200 &&
                                            isLast;

                                        if (!showToggle) {
                                            return (
                                                <p key={index}>{paragraph}</p>
                                            );
                                        }

                                        if (!descMore) {
                                            const text = paragraph.endsWith(
                                                "..."
                                            )
                                                ? paragraph.slice(0, -3)
                                                : paragraph;
                                            return (
                                                <p key={index}>
                                                    {text}
                                                    ...
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setDescMore(true)
                                                        }
                                                    >
                                                        {t("more.label")}
                                                    </button>
                                                </p>
                                            );
                                        }

                                        return (
                                            <p key={index}>
                                                {paragraph}{" "}
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setDescMore(false)
                                                    }
                                                >
                                                    {t("collapse.label")}
                                                </button>
                                            </p>
                                        );
                                    }
                                )}
                            </div>
                        )}
                        <div className="nav-tab">
                            <NavBar
                                id={id}
                                currentTab={currentTab}
                                setCurrentTab={setCurrentTab}
                            />
                        </div>
                        {props.children}
                        {/*             
            {
              currentTab === 2 
              ?
              <Rating />: null
            } */}
                    </div>
                </div>
            ) : (
                <div className="loader">
                    <Navigate to={`/feedback/${id}`} />
                </div>
            )}
        </>
    );
}
